var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleSideArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4498 6.5625L10.3873 7.5L13.6123 4.26563L10.3123 0.9375L9.3748 1.875L11.0623 3.5625H1.8748V4.875H11.0811L9.4498 6.5625ZM5.49355 8.4375L4.55605 7.5L1.33105 10.7812L4.60293 14.0625L5.54043 13.125L3.84355 11.4375H13.1248V10.125H3.84355L5.49355 8.4375Z",
    fill: "#0066CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleSideArrow);
export default __webpack_public_path__ + "static/media/doubleSideArrow.cbc1e77e6e1756021bf2d539878a456c.svg";
export { ForwardRef as ReactComponent };